import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
	data: {
		// stats
		totalCorrect: null,
		totalWrong: null,
		avgCountIndividualQuestions: null,
		avgExamGrade: null,
		avgExamCount: null,
		totalExams: null,
		points: null,

		// graphs
		dailyGraphQuestionsData: null,
		examCountByGradeData: null,
		avgExamGradeLastTwoWeeks: null,

		// user
		rank: null,
		countNotifications: null
	},
	error: null,
	loading: false
};

const fetchDashboardStatsStart = (state, action) =>
	updateObject(state, { loading: true, error: null });

const fetchDashboardStatsSuccess = (state, action) => {
	const newState = {
		dailyGraphQuestionsData: action.stats.message.DailyGraphQuestionsData,
		examCountByGradeData: action.stats.message.ExamCountByGradeData,
		examCountByMonthWeeks: action.stats.message.ExamCountByLastMonthWeekData,
		avgCountIndividualQuestions: action.stats.message.Statistics.AvgCountIndividualQuestions,
		avgExamGrade: action.stats.message.Statistics.AvgExamGrade,
		avgExamGradeLastTwoWeeks: action.stats.message.AVGExamGrade,
		totalCorrect: action.stats.message.Statistics.LastMonthTotalCorrect,
		totalWrong: action.stats.message.Statistics.LastMonthTotalWrong,
		totalExams: action.stats.message.Statistics.TotalExams,
		avgExamCount: action.stats.message.Statistics.AvgExamCount,
		points: action.stats.message.Statistics.TotalPoints,
		rank: action.stats.message.Rank,
		countNotifications: action.stats.message.CountNotifications
	};
	return updateObject(state, { data: newState, loading: false });
};

const fetchDashboardStatsFail = (state, action) =>
	updateObject(state, { error: action.error, loading: false });

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.FETCH_DASHBOARD_STATS_START:
			return fetchDashboardStatsStart(state, action);
		case actionTypes.FETCH_DASHBOARD_STATS_SUCCESS:
			return fetchDashboardStatsSuccess(state, action);
		case actionTypes.FETCH_DASHBOARD_STATS_FAIL:
			return fetchDashboardStatsFail(state, action);
		default:
			return state;
	}
};

export default reducer;
